import { memo } from 'react';
import MainLayoutContainer from '@layouts/main-layout/container';
import { StyledSkeletonContainer, StyledSkeleton } from '@styles/app.styles';

const MainLayoutLoader = memo(function MainLayoutLoader() {
	return (
		<MainLayoutContainer>
			<StyledSkeletonContainer>
				<StyledSkeleton width="100%" height={48} />
				<StyledSkeleton width="100%" height={48} />
				<StyledSkeleton width="100%" height={48} />
				<StyledSkeleton width="100%" height={48} />
			</StyledSkeletonContainer>
		</MainLayoutContainer>
	);
});

export default MainLayoutLoader;
